/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ExportRequestGenericOntology } from '../../models/export-request-generic-ontology';

export interface AddAlarmOntologyExportRequest$Params {

/**
 * The object ID. Must be a valid ID.
 */
  uid: string;
  
    /**
     * Body for new ontology on demand of export
     */
    body: ExportRequestGenericOntology
}

export function addAlarmOntologyExportRequest(http: HttpClient, rootUrl: string, params: AddAlarmOntologyExportRequest$Params, context?: HttpContext): Observable<StrictHttpResponse<ExportRequestGenericOntology>> {
  const rb = new RequestBuilder(rootUrl, addAlarmOntologyExportRequest.PATH, 'post');
  if (params) {
    rb.path('uid', params.uid, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ExportRequestGenericOntology>;
    })
  );
}

addAlarmOntologyExportRequest.PATH = '/export-request/{uid}/ontology/alarm';
